import { AppQueryParams } from '@doda/common/src/constants/queryParams';
import { OP_SEARCH_ITEMS } from '@doda/common/src/constants/searchItems';
import {
  EmployeeAverageAgeRequestCode,
  EmploymentStatusRequestCode,
  HolidayAndWayOfWorkingRequestCode,
  LanguageSkillsRequestCode,
  PositionsRequestCode,
  RequirementsRequestCode,
  WelfareBenefitsRequestCode,
  WorkplaceEnvironmentRequestCode,
} from '@doda/api-client/aspida/@types';
import {
  NEW_OP_PARAM,
  DEADLINE_OP_PARAM,
  TEMPORARY_WORKER_OP_PARAM,
  TEMP_TO_PERM_OP_PARAM,
  OUTSOURCING_OP_PARAM,
  FC_OWNER_OP_PARAM,
} from '@doda/common/src/constants/seo/jobContentCommonConstants';
import { createOpParams } from './createOpParams';

/**
 * オプションのAPIリクエスト作成
 * @param queryParams クエリパラメータ
 * @returns オプションのAPIリクエスト
 */
export const createOptionApiRequest = (queryParams: AppQueryParams) => {
  let optionName = '';
  let opId = '';

  const opList = Object.keys(OP_SEARCH_ITEMS).map(
    (key) => OP_SEARCH_ITEMS[key]
  );
  if (queryParams.op) [opId] = queryParams.op;
  const findOp = opList.find((option) => option.id === opId);
  if (
    opId === NEW_OP_PARAM ||
    opId === DEADLINE_OP_PARAM ||
    opId === TEMPORARY_WORKER_OP_PARAM ||
    opId === TEMP_TO_PERM_OP_PARAM ||
    opId === OUTSOURCING_OP_PARAM ||
    opId === FC_OWNER_OP_PARAM
  ) {
    // 新着・締め切り間近・その他雇用形態を除く
    throw new Error('パラメータの不正(op)');
  }
  if (findOp) {
    optionName = findOp.name;
  } else {
    // マスタに存在する値かの判定
    throw new Error('パラメータの不正(op)');
  }

  const hydrogenOp = createOpParams(queryParams.op);
  // 社員の平均年齢
  if (hydrogenOp.employeeAverageAge) {
    optionName = opList.find((option) => option.id === opId).seoText;
  }

  const requestEmploymentStatusId = hydrogenOp.employmentStatus
    ? (hydrogenOp.employmentStatus as EmploymentStatusRequestCode[])
    : undefined;
  const requestHolidayAndWayOfWorkingId = hydrogenOp.holidayAndWayOfWorking
    ? (hydrogenOp.holidayAndWayOfWorking as HolidayAndWayOfWorkingRequestCode[])
    : undefined;
  const requestRequirementsId = hydrogenOp.requirements
    ? (hydrogenOp.requirements as RequirementsRequestCode[])
    : undefined;
  const requestWorkplaceEnvironmentId = hydrogenOp.workplaceEnvironment
    ? (hydrogenOp.workplaceEnvironment as WorkplaceEnvironmentRequestCode[])
    : undefined;
  const requestWelfareBenefitsId = hydrogenOp.welfareBenefits
    ? (hydrogenOp.welfareBenefits as WelfareBenefitsRequestCode[])
    : undefined;
  const requestLanguageSkillsId = hydrogenOp.languageSkills
    ? (hydrogenOp.languageSkills as LanguageSkillsRequestCode[])
    : undefined;
  const requestPositionsId = hydrogenOp.positions
    ? (hydrogenOp.positions as PositionsRequestCode[])
    : undefined;
  const requestEmployeeAverageAgeId = hydrogenOp.employeeAverageAge
    ? (hydrogenOp.employeeAverageAge as EmployeeAverageAgeRequestCode[])
    : undefined;

  return {
    optionName,
    requestEmploymentStatusId,
    requestHolidayAndWayOfWorkingId,
    requestRequirementsId,
    requestWorkplaceEnvironmentId,
    requestWelfareBenefitsId,
    requestLanguageSkillsId,
    requestPositionsId,
    requestEmployeeAverageAgeId,
  };
};
